import request from '@/utils/request'

//  新增商品
export const addItem = (formData) => {
    return request.post('/goods', formData)
}

//  商品列表
export const itemList = (pageData, formData) => {
    return request.post(`/goods/${pageData.page}/${pageData.pageSize}`, formData)
}

//  查询商品详情
export const itemDetail = (id) => {
    return request.get(`/goods/${id}`)
}

//  修改商品
export const editItem = (updateData) => {
    return request.put('/goods', updateData)
}

// 商品设置渠道
//
export const editGoodsSalesChannel = (updateData) => {
    return request.post('/goods/saleChannel', updateData)
}

//  上下架-门店商品列表
export const listStoreGoods = (pageData, formData) => {
    return request.get(`/goods/storeGoodsList/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

//  上下架-网店商品列表
export const listOnlineStoreGoodsList = (pageData, formData) => {
    return request.get(`/goods/onlineStoreGoodsList/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

//  修改门店商品-上下架状态
export const changeStoreGoodsState = (updateData) => {
    return request.put('/goods/storeGoodsState', updateData)
}

//  修改网店商品-上下架状态
export const changeOnlineStoreGoodsState = (updateData) => {
    return request.put('/goods/onlineStoreGoodsState', updateData)
}

// 新增组合商品
export const addComboItem = (formData) => {
    return request.post('/comboGoods', formData)
}

// 修改组合商品
export const editComboItem = (updateData) => {
    return request.put(`/comboGoods/${updateData.goodsId}`, updateData)
}

// 跨租户商品列表-通过名称|租户id查找
export const listGoodsIgnoreTenant = (pageData, formData) => {
    return request.post(`/goods/ignoreTenant/${pageData.page}/${pageData.pageSize}`, formData)
}

// 新增-商城商品
export const addMallItem = (formData) => {
    return request.post('/mall-goods/add', formData)
}

// 修改-商城商品
export const editMallItem = (updateData) => {
    return request.put(`/mall-goods/update`, updateData)
}

// 复制-商城商品
export const copyMallItem = (goodsId) => {
    return request.post(`/mall-goods/copy/${goodsId}`)
}

// 上下架商品
export const upOrDownTheShelf = (formData) => {
    return request.put(`/goods/state`, formData)
}
